import React from 'react';
import { ListColumnType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import ModulePriceForm from './ModulePriceForm';
import { currencySymbols } from 'internationalization/currencySymbols';
import { parsePriceToStringOnUserLocale } from 'services/utils/parsePriceString';
import { useSettings } from 'services/settings/SettingsContext';
import { useTranslation } from 'react-i18next';

// Rename the name of the function:
const ModulePriceList: React.FC = () => {
    const { t } = useTranslation();
    const { userLocale } = useSettings();

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        { 
            width: '1fr', 
            field: 'feature_translation', 
            label: 'billing.module_price.module_name_label', 
            translationString: true 
        },
        { 
            width: '2fr', 
            field: 'price', 
            label: 'billing.module_price.price_label', 
            render: (_, row) => renderPriceColumn(
                row.price_type, 
                row.flat_price, 
                row.price_per_seat, 
                row.enable_threshold,
                row.threshold,
                row.price_above_threshold
            )
        },
    ];

    // Render price column
    const renderPriceColumn = (
        price_type: string, 
        flat_price: string, 
        price_per_seat: string, 
        enable_threshold: boolean,
        threshold: string,
        price_above_threshold: string,
    ) => {    

        // Format the per unit price type
        if (price_type === 'per_unit') {

            // Format the unit price
            const formattedPrice = parsePriceToStringOnUserLocale(flat_price, userLocale, false);

            return (
                <span>
                    {currencySymbols['eur']} {formattedPrice} / {t('billing.module_price.per_month_label')}
                </span>
            )
        }

        // Format the per seat price type
        if (price_type === 'per_seat') {

            // If the threshold is enabled, show the maximized price
            if (enable_threshold === true) {

                // Format the seat price
                const formattedSeatPrice = parsePriceToStringOnUserLocale(price_per_seat, userLocale, false);

                // Format the maximized price
                const formattedMaximizedPrice = parsePriceToStringOnUserLocale(price_above_threshold, userLocale, false);

                return (
                    <span>
                        {currencySymbols['eur']} {formattedSeatPrice} / {t('billing.module_price.per_seat_per_month_label_threshold', { 
                            threshold: parseInt(threshold), 
                            currency: currencySymbols['eur'], 
                            formattedMaximizedPrice 
                        })}
                    </span>
                )

            } else {
                // Format the seat price
                const formattedSeatPrice = parsePriceToStringOnUserLocale(price_per_seat, userLocale, false);

                return (
                    <span>
                        {currencySymbols['eur']} {formattedSeatPrice} / {t('billing.module_price.per_seat_per_month_label')}
                    </span>
                )
            }
        }

        return (<span></span>);
    }

    return (
        <AbstractList
            query={{
                endpoint: 'get_module_price_list',
                defaultParams: { is_active: true },
                object: 'module_price'
            }}
            objectName='billing.module_price.object_name'
            columns={columns}
            showSearch={false}
            showAddButton={false}
            isPaginated={false}
            isDraggable={true}
            draggingApiUrl='patch_module_price_ordering'
            showDeleteOrDeactivate='flag_deactivated'
            formModal={<ModulePriceForm />}
            onRowClick='editModal'
        />
    );
};

export default ModulePriceList;